import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTableModule, MatRadioModule } from '@angular/material';
import { ProgramsRoutingModule } from './programs-routing.module';
import { ProgramsComponent } from './programs.component';
import { CommonModule } from '@angular/common';
import { ProgramService } from './shared/program.service';
import { FacultyService } from './shared/faculty.service';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatTableModule,
    ProgramsRoutingModule
  ],
  declarations: [ProgramsComponent],
  exports: [ProgramsComponent, ProgramsRoutingModule],
  providers: [ProgramService, FacultyService]
})
export class ProgramsModule { }
